import { MagneticButton } from "@/components/magnetic-button";
import jonPhoto from "@/assets/profile-photo.webp.asset.json";

type Props = {
  variant?: "dark" | "light" | "outline-dark" | "outline-light";
  immersive?: boolean;
  className?: string;
};

/**
 * Shared "Talk to Jon" CTA — Jon's avatar + the Cal.com booking link,
 * baked in so every call-to-action across the site stays identical.
 */
export function TalkToJonButton({ variant = "dark", ...rest }: Props) {
  return (
    <MagneticButton
      href="https://cal.com/vibinc/30min"
      target="_blank"
      rel="noopener noreferrer"
      variant={variant}
      avatar={jonPhoto.url}
      {...rest}
    >
      Talk to Jon <span aria-hidden>→</span>
    </MagneticButton>
  );
}
